/**
 * level_01.ts — "Verdis" (local pub, tutorial).
 * The first venue. Introduces movement, building, and the first light waves.
 * Wave timings/composition below are seeds to tune during balancing (§3.4, §9.6).
 */

import type { LevelDefinition } from '../../types';

export const LEVEL_01: LevelDefinition = {
  id: 'level_01',
  name: 'Verdis',
  description:
    'A local pub. Defend Nigel’s Future Beacon through your first gigs while you learn the ropes.',
  waves: [
    {
      delay: 120,
      enemies: [{ type: 'GenZSwarm', count: 6, spawnEdge: 'north' }],
      warningTime: 20,
    },
    {
      delay: 240,
      enemies: [
        { type: 'GenZSwarm', count: 8, spawnEdge: 'north' },
        { type: 'StreamingMogul', count: 1, spawnEdge: 'east' },
      ],
      warningTime: 20,
    },
  ],
};
